import React from "react";

const ProgressBar = ({ goalProgress, goal }) => {
  const progress = goal > 0 ? (goalProgress / goal) * 100 : 0;

  return (
    <div className="task-list-item-context-list-item-qty mt-2">
      <div className="task-scale-bar">
        <div
          className={`task-scale-bar-progress ${
            goalProgress === goal && "complete"
          }`}
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className="task-scale-bar-label">
        {goalProgress}/{goal}
      </div>
    </div>
  );
};

export default ProgressBar;
